// extracted by mini-css-extract-plugin
export var component = "BillboardModule-module--component--jT7hH";
export var header = "BillboardModule-module--header--ETqE+";
export var item = "BillboardModule-module--item--PmDBq";
export var list = "BillboardModule-module--list--A4Fjz";
export var preamble = "BillboardModule-module--preamble--+xrzy";